import type { ComponentStyle } from "@yamada-ui/core"

export const CircleProgress: ComponentStyle<"CircleProgress"> = {
  baseStyle: {
    display: "inline-block",
    position: "relative",
    verticalAlign: "middle",
  },
}
